const videoSources = {
  COMPUTER: 'computer',
  DROPBOX: 'dropbox',
  GOOGLE_DRIVE: 'drive',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook',
};

export const externalVideoSources = [
  videoSources.YOUTUBE,
  videoSources.VIMEO,
  videoSources.FACEBOOK,
];

export default videoSources;



// WEBPACK FOOTER //
// ./src/shared/constants/video-sources.js